export const metalDetectionQueryKeys = {
  all: ['metal-detection'] as const,
  detectors: () => ['metal-detection', 'detectors'] as const,
  calendar: (from: string, to: string) => ['metal-detection', 'calendar', from, to] as const,
  records: (from: string, to: string) => ['metal-detection', 'records', from, to] as const,
  detectorHistory: (id: string, from: string | null, to: string | null) =>
    ['metal-detection', 'detector-history', id, from, to] as const,
};
